import { Button } from 'uikit'
import { useSetTrustedUser } from './services/useSetTrustedUser'
import { useSetUntrustedUser } from './services/useSetUntrustedUser'

export const TrustUser = ({ userId, trusted, disabled }) => {
  const { mutate: setTrusted, isLoading: trustedIsLoading } = useSetTrustedUser(userId)
  const { mutate: setUntrusted, isLoading: untrustedIsLoading } = useSetUntrustedUser(userId)

  const handleSubmit = () => {
    if (trusted) {
      setUntrusted()
    } else {
      setTrusted()
    }
  }

  const isLoading = trustedIsLoading || untrustedIsLoading

  return (
    <Button
      width="100%"
      onClick={handleSubmit}
      colorPalette={!trusted ? 'green' : 'orange'}
      loading={isLoading}
      disabled={disabled}
    >
      {!trusted ? 'Добавить в белый список' : 'Убрать из белого списка'}
    </Button>
  )
}
